'use client'

import { Button } from '@vinted/web-ui'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useSession } from '@marketplace-web/shared/session-data'
import { urlWithParams } from '@marketplace-web/browser/url-util'
import { clickEvent } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import { ListingSectionModel } from '../../types'
import { ITEM_UPLOAD_URL, SIGNUP_URL } from '../../../../constants/routes'

type Props = { props: ListingSectionModel }

const ListingSection = ({ props }: Props) => {
  const { text, testId } = props
  const translate = useTranslate()
  const isListingCtaEnabled = useFeatureSwitch('dac7_listing_cta')
  const { track } = useTracking()
  const userId = useSession().user?.id

  const ctaUrl = userId
    ? ITEM_UPLOAD_URL
    : urlWithParams(SIGNUP_URL, {
        ref_url: ITEM_UPLOAD_URL,
      })

  const onCtaClick = () => {
    track(
      clickEvent({
        screen: 'no_changes_to_taxes',
        target: 'cta_redirect',
        targetDetails: `ready_to_go_start_selling__${userId ? ITEM_UPLOAD_URL : SIGNUP_URL}`,
      }),
    )
  }
  if (!isListingCtaEnabled) return null

  return (
    <section className="secondhand-taxes__listing-section" data-testid={testId}>
      <h3 className="secondhand-taxes__listing-section-title">{translate(text.title)}</h3>
      <div className="secondhand-taxes__listing-section-cta">
        <Button
          text={translate(text.cta)}
          inverse
          styling="filled"
          url={ctaUrl}
          onClick={onCtaClick}
        />
      </div>
    </section>
  )
}

export default ListingSection
